import React from "react";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import AuthContainer, {
	AuthContainerSignIn,
	AuthContainerSignUp,
} from "@insightfulscience/atomic-react/r1/molecules/AuthContainer";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import { withErrorHandling } from "@src/AppError";
import SiteLayout from "@src/SiteLayout";
import LoginForm from "@src/LoginForm";
import RegistrationForm from "@src/RegistrationForm";
import redirectIf from "@src/utils/redirectIf";
import { isAuthorized } from "@src/services/auth";
import routes, { toReturnUrl } from "@src/routes";
import resources from "../../locales/login-page";

const RegisterLoginPage = () => {
	const [t] = useLocale("login-page");
	return (
		<SiteLayout>
			<PageTitle title={t("PAGE_TITLE")} />
			<AuthContainer>
				<AuthContainerSignUp>
					<RegistrationForm />
				</AuthContainerSignUp>
				<AuthContainerSignIn>
					<LoginForm />
				</AuthContainerSignIn>
			</AuthContainer>
		</SiteLayout>
	);
};

export default pipe(
	RegisterLoginPage,
	WithLocale({ resources }),
	redirectIf(isAuthorized, toReturnUrl(routes.myAccount)),
	withErrorHandling,
);
